import { render, staticRenderFns } from "./imageUpload.vue?vue&type=template&id=128faccb&scoped=true"
import script from "./imageUpload.vue?vue&type=script&lang=js"
export * from "./imageUpload.vue?vue&type=script&lang=js"
import style0 from "./imageUpload.vue?vue&type=style&index=0&id=128faccb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128faccb",
  null
  
)

export default component.exports